import styles from "./toolbox-all-map-labels.module.css";
import { useState } from "react";
import { UploadedPhotosGrid } from "../asset-import/images-section/uploaded-photos-grid";
import { PhotoWithCoordinates } from "PosterEditor/model/poster-project";
import { InfoBox } from "BEDROCK/shared-components/info-box";
import { DownloadAppInfoBox } from "./download-app-info-box";
import { ToolboxSectionDivider as Divider } from "../../toolbox-components/toolbox-component-section";
import { has } from "lodash";

interface UploadedPhotosSectionProps {}

export const UploadedPhotosSection = (props: UploadedPhotosSectionProps) => {
  const [hasUploadedPhotos, setHasUploadedPhotos] = useState<
    boolean | undefined
  >();

  return (
    <div className={styles.photosSection}>
      {hasUploadedPhotos === false && <DownloadAppInfoBox />}
      {hasUploadedPhotos === true && (
        <InfoBox
          title="Uploads"
          description="Uploaded photos from the TrailArt iPhone app. Click a photo to apply it to your project."
          iconName="IPHONE-UPLOAD"
        />
      )}

      <Divider whitespaceOnly />
      <UploadedPhotosGrid
        onLoadURLs={(urls) => {
          setHasUploadedPhotos(urls.length > 0);
        }}
      />
    </div>
  );
};
